import api from '..';

export type saveCardTokenPayload = {
  venda_id: number;
  cliente_cpf: string;
  cartao_tokenizado: string;
  cartao_cvv: string;
};

export const requestSaveTokenizedCard = async (
  payload: saveCardTokenPayload,
) => {
  const { data } = await api.put('/core/vendas/tokenizar-cartao', payload);

  return data;
};
